import { SpineMeshUtils } from "../mesh/SpineMeshUtils";
export class VBCreator {
    constructor(vertexFlag, maxVertexCount = 0, auto = true) {
        this._vertexSize = 0;
        this._baseVtxCount = 6;
        this._boneVtxCount = 4;
        this.twoColorTint = false;
        this.boneMaxId = 0;
        this.maxVertexCount = maxVertexCount;
        this.vertexFlag = vertexFlag;
        this.mapIndex = new Map();
        this.slotVBMap = new Map();
        this.boneArray = [];
        this.vbLength = 0;
        if (auto) {
            this._vertexDeclaration = SpineMeshUtils.getVertexDeclaration(this.vertexFlag);
            this.twoColorTint = vertexFlag.indexOf("COLOR2") != -1;
            if (this.twoColorTint)
                this._baseVtxCount += 4;
            this._vertexSize = this._vertexDeclaration.vertexStride / 4;
            this._boneVtxCount = this._vertexSize - this._baseVtxCount;
            this._updateBuffer();
        }
    }
    setBufferLength(maxVertexCount) {
        if (maxVertexCount <= this.maxVertexCount)
            return;
        this.maxVertexCount = maxVertexCount;
        this._updateBuffer();
    }
    _updateBuffer() {
        let oldbuffer = this.vb;
        this.vb = new Float32Array(this.maxVertexCount * this.vertexSize);
        if (oldbuffer)
            this.vb.set(oldbuffer);
    }
    get vertexSize() {
        return this._vertexSize;
    }
    get vertexDeclaration() {
        return this._vertexDeclaration;
    }
    appendAndCreateIB(attach) {
        this.appendVB(attach);
    }
    getBoneId(boneIndex) {
        let id = this.mapIndex.get(boneIndex);
        if (id == undefined) {
            id = this.boneMaxId;
            this.mapIndex.set(boneIndex, id);
            this.boneArray.push(id, boneIndex);
            this.boneMaxId++;
        }
        return id;
    }
    initBoneMat() {
        this.boneMat = new Float32Array(8 * this.mapIndex.size);
    }
    appendVB(attach) {
        let offset;
        let map = this.slotVBMap.get(attach.slotId);
        if (map) {
            let offset = map.get(attach.attachment);
            if (offset != undefined) {
                return offset;
            }
        }
        else {
            map = new Map();
            this.slotVBMap.set(attach.slotId, map);
        }
        offset = this.vbLength / this.vertexSize;
        map.set(attach.attachment, { offset: offset, attachment: attach });
        if (!attach.vertexCount)
            return offset;
        if (offset + attach.vertexCount >= this.maxVertexCount) {
            this.setBufferLength(offset + attach.vertexCount);
        }
        this.vbLength = this.appendVertexArray(attach, this.vb, this.vbLength, this);
        return offset;
    }
    resetVB(attach) {
        var _a;
        if (attach.isPath) {
            return;
        }
        let pos = (_a = this.slotVBMap.get(attach.slotId)) === null || _a === void 0 ? void 0 : _a.get(attach.attachment);
        if (pos) {
            this.appendVertexArray(attach, this.vb, pos.offset * this.vertexSize, this);
        }
    }
    updateBone(bones, boneMat, ofx = 0, ofy = 0) {
        let boneArray = this.boneArray;
        for (let i = 0, n = boneArray.length; i < n; i += 2) {
            let offset = boneArray[i] * 8;
            let bone = bones[boneArray[i + 1]];
            boneMat[offset] = bone.a;
            boneMat[offset + 1] = bone.b;
            boneMat[offset + 2] = bone.worldX + ofx;
            boneMat[offset + 3] = 0;
            boneMat[offset + 4] = bone.c;
            boneMat[offset + 5] = bone.d;
            boneMat[offset + 6] = bone.worldY + ofy;
            boneMat[offset + 7] = 0;
        }
    }
    updateBoneCache(boneFrames, frames, boneMat, ofx = 0, ofy = 0) {
        let boneArray = this.boneArray;
        let floor = Math.floor(frames);
        let detal;
        if (floor == boneFrames.length - 1) {
            detal = 0;
        }
        else {
            detal = frames - floor;
        }
        let boneFrames1 = boneFrames[floor];
        let boneFrames2 = boneFrames[floor + 1];
        if (detal > 0.0001) {
            for (let i = 0, n = boneArray.length; i < n; i += 2) {
                let offset = boneArray[i] * 8;
                let boneFloatArray = boneFrames1[boneArray[i + 1]];
                let boneFloatArray2 = boneFrames2[boneArray[i + 1]];
                boneMat[offset] = boneFloatArray[0] + (boneFloatArray2[0] - boneFloatArray[0]) * detal;
                boneMat[offset + 1] = boneFloatArray[1] + (boneFloatArray2[1] - boneFloatArray[1]) * detal;
                boneMat[offset + 2] = boneFloatArray[2] + (boneFloatArray2[2] - boneFloatArray[2]) * detal;
                boneMat[offset + 3] = 0;
                boneMat[offset + 4] = boneFloatArray[4] + (boneFloatArray2[4] - boneFloatArray[4]) * detal;
                boneMat[offset + 5] = boneFloatArray[5] + (boneFloatArray2[5] - boneFloatArray[5]) * detal;
                boneMat[offset + 6] = boneFloatArray[6] + (boneFloatArray2[6] - boneFloatArray[6]) * detal;
                boneMat[offset + 7] = 0;
            }
        }
        else {
            for (let i = 0, n = boneArray.length; i < n; i += 2) {
                let offset = boneArray[i] * 8;
                let bone = boneFrames1[boneArray[i + 1]];
                boneMat.set(bone, offset);
            }
        }
    }
    _cloneTo(target) {
        target.vb = new Float32Array(this.vb);
        target.vbLength = this.vbLength;
        target.mapIndex = new Map(this.mapIndex);
        target.boneMaxId = this.boneMaxId;
        target.boneArray = this.boneArray.slice();
        target._vertexDeclaration = this._vertexDeclaration;
        target._vertexSize = this._vertexSize;
        target.twoColorTint = this.twoColorTint;
        target._baseVtxCount = this._baseVtxCount;
        target._boneVtxCount = this._boneVtxCount;
        target.vertexFlag = this.vertexFlag;
        this.slotVBMap.forEach((value, key) => {
            target.slotVBMap.set(key, new Map(value));
        });
    }
    clone() {
        let rs = this._create();
        this._cloneTo(rs);
        return rs;
    }
}
export class VBBoneCreator extends VBCreator {
    _create() {
        return new VBBoneCreator(this.vertexFlag, this.maxVertexCount, false);
    }
    appendVertexArray(attachmentParse, vertexArray, offset, boneGet) {
        if (!attachmentParse.attachment) {
            boneGet.getBoneId(attachmentParse.boneIndex);
            return offset;
        }
        let vside = this.vertexSize;
        let slotVertex = attachmentParse.vertexArray;
        let uvs = attachmentParse.uvs;
        let color = attachmentParse.color;
        let c1r = color.r, c1g = color.g, c1b = color.b, c1a = color.a;
        let boneNum = this._boneVtxCount / 4;
        let color2 = attachmentParse.darkColor;
        let c2r = 0, c2g = 0, c2b = 0, c2a = 1;
        if (color2) {
            c2r = color2.r;
            c2g = color2.g;
            c2b = color2.b;
            c2a = color2.a;
        }
        if (attachmentParse.stride == 2) {
            let boneid = boneGet.getBoneId(attachmentParse.boneIndex);
            for (let j = 0, n = slotVertex.length; j < n; j += attachmentParse.stride) {
                vertexArray[offset] = uvs[j];
                vertexArray[offset + 1] = uvs[j + 1];
                vertexArray[offset + 2] = c1r;
                vertexArray[offset + 3] = c1g;
                vertexArray[offset + 4] = c1b;
                vertexArray[offset + 5] = c1a;
                vertexArray[offset + 6] = slotVertex[j];
                vertexArray[offset + 7] = slotVertex[j + 1];
                vertexArray[offset + 8] = 1;
                vertexArray[offset + 9] = boneid;
                let ox = offset + 10;
                for (let z = 0, len = boneNum - 1; z < len; z++) {
                    let vOffset = ox + z * 4;
                    vertexArray[vOffset] = 0;
                    vertexArray[vOffset + 1] = 0;
                    vertexArray[vOffset + 2] = 0;
                    vertexArray[vOffset + 3] = 0;
                }
                if (this.twoColorTint) {
                    let tColorOffset = offset + 6 + this._boneVtxCount;
                    vertexArray[tColorOffset] = c2r;
                    vertexArray[tColorOffset + 1] = c2g;
                    vertexArray[tColorOffset + 2] = c2b;
                    vertexArray[tColorOffset + 3] = c2a;
                }
                offset += vside;
            }
        }
        else {
            for (let j = 0, uvid = 0, n = slotVertex.length; j < n; j += attachmentParse.stride, uvid += 2) {
                vertexArray[offset] = uvs[uvid];
                vertexArray[offset + 1] = uvs[uvid + 1];
                vertexArray[offset + 2] = c1r;
                vertexArray[offset + 3] = c1g;
                vertexArray[offset + 4] = c1b;
                vertexArray[offset + 5] = c1a;
                let ox = offset + 6;
                for (let z = 0; z < boneNum; z++) {
                    let vOffset = ox + z * 4;
                    let oOffset = j + z * 4;
                    vertexArray[vOffset] = slotVertex[oOffset];
                    vertexArray[vOffset + 1] = slotVertex[oOffset + 1];
                    vertexArray[vOffset + 2] = slotVertex[oOffset + 2];
                    vertexArray[vOffset + 3] = boneGet.getBoneId(slotVertex[oOffset + 3]);
                }
                if (this.twoColorTint) {
                    let tColorOffset = ox + this._boneVtxCount;
                    vertexArray[tColorOffset] = c2r;
                    vertexArray[tColorOffset + 1] = c2g;
                    vertexArray[tColorOffset + 2] = c2b;
                    vertexArray[tColorOffset + 3] = c2a;
                }
                offset += vside;
            }
        }
        return offset;
    }
    appendDeform(attachmentParse, deform, offset, out) {
        if (!attachmentParse.attachment) {
            return;
        }
        let vside = this.vertexSize;
        let slotVertex = attachmentParse.vertexArray;
        if (attachmentParse.stride == 2) {
            for (let j = 0, n = slotVertex.length; j < n; j += attachmentParse.stride) {
                out[offset + 6] = deform[j];
                out[offset + 7] = deform[j + 1];
                offset += vside;
            }
        }
        else {
            let attchment = attachmentParse.sourceData;
            let bones = attchment.bones;
            let vertexCount = attachmentParse.vertexCount;
            let boneNum = this._boneVtxCount / 4;
            let f = 0, v = 0;
            for (let w = 0; w < vertexCount; w++) {
                let len = bones[v++];
                let slotOffset = w * this._boneVtxCount;
                let vertexOffset = offset + w * vside + 6;
                for (let i = 0; i < len; i++) {
                    if (i >= boneNum)
                        break;
                    let deformOffset = f + i * 2;
                    let slotIndex = slotOffset + i * 4;
                    let boneOffset = vertexOffset + i * 4;
                    out[boneOffset] = slotVertex[slotIndex] + deform[deformOffset];
                    out[boneOffset + 1] = slotVertex[slotIndex + 1] + deform[deformOffset + 1];
                }
                v += len;
                f += 2 * len;
            }
        }
    }
}
export class VBRigBodyCreator extends VBCreator {
    _create() {
        return new VBRigBodyCreator(this.vertexFlag, this.maxVertexCount, false);
    }
    appendVertexArray(attachmentParse, vertexArray, offset, boneGet) {
        let slotVertex = attachmentParse.vertexArray;
        let uvs = attachmentParse.uvs;
        let color = attachmentParse.color;
        let color2 = attachmentParse.darkColor;
        let vside = this.vertexSize;
        let c1r = color.r, c1g = color.g, c1b = color.b, c1a = color.a;
        let c2r = 0, c2g = 0, c2b = 0, c2a = 1;
        if (color2) {
            c2r = color2.r;
            c2g = color2.g;
            c2b = color2.b;
            c2a = color2.a;
        }
        if (attachmentParse.stride == 2) {
            let boneid = boneGet.getBoneId(attachmentParse.boneIndex);
            for (let j = 0, n = slotVertex.length; j < n; j += attachmentParse.stride) {
                vertexArray[offset + 0] = uvs[j];
                vertexArray[offset + 1] = uvs[j + 1];
                vertexArray[offset + 2] = c1r;
                vertexArray[offset + 3] = c1g;
                vertexArray[offset + 4] = c1b;
                vertexArray[offset + 5] = c1a;
                vertexArray[offset + 6] = slotVertex[j];
                vertexArray[offset + 7] = slotVertex[j + 1];
                vertexArray[offset + 8] = boneid;
                if (this.twoColorTint) {
                    let tColorOffset = offset + 9;
                    vertexArray[tColorOffset] = c2r;
                    vertexArray[tColorOffset + 1] = c2g;
                    vertexArray[tColorOffset + 2] = c2b;
                    vertexArray[tColorOffset + 3] = c2a;
                }
                offset += vside;
            }
        }
        else {
        }
        return offset;
    }
    appendDeform(attachmentParse, deform, offset, out) {
        if (!attachmentParse.attachment) {
            return;
        }
        let vside = this.vertexSize;
        let slotVertex = attachmentParse.vertexArray;
        if (attachmentParse.stride == 2) {
            for (let j = 0, n = slotVertex.length; j < n; j += attachmentParse.stride) {
                out[offset + 6] = deform[j];
                out[offset + 7] = deform[j + 1];
                offset += vside;
            }
        }
    }
}
